import { useTranslate } from '@growtherapy/i18n';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@growtherapy/sprout-ui';

import { LocaleDetectionPromptConfig } from './browserLanguagePromptConfig';

type BrowserLanguagePromptModalProps = {
  isOpen: boolean;
  config: LocaleDetectionPromptConfig;
  onKeepEnglish: () => void;
  onSwitchLanguage: () => void;
};

export function BrowserLanguagePromptModal({
  isOpen,
  config,
  onKeepEnglish,
  onSwitchLanguage,
}: BrowserLanguagePromptModalProps) {
  const t = useTranslate();

  return (
    <Modal isOpen={isOpen} onClose={onKeepEnglish} className='rebrand:rounded-none sm:!top-1/2 sm:!-translate-y-1/2'>
      <ModalHeader>{config.headerText}</ModalHeader>
      <ModalBody>{config.bodyText}</ModalBody>
      <ModalFooter
        actions={[
          {
            key: 'keep-english',
            use: 'secondary',
            onClick: onKeepEnglish,
            actionContent: t('telehealth-core:settings.keepEnglish'),
          },
          {
            key: 'switch-language',
            use: 'primary',
            onClick: onSwitchLanguage,
            actionContent: config.actionCta,
          },
        ]}
      />
    </Modal>
  );
}
